import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=6e163d25&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"
import style0 from "./Files.vue?vue&type=style&index=0&id=6e163d25&prod&lang=scss"
import style1 from "./Files.vue?vue&type=style&index=1&id=6e163d25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e163d25",
  null
  
)

export default component.exports